/* eslint-disable @typescript-eslint/ban-types */
import { ICookieConsent } from "@containers/Cookies/type";
import { callAPI } from "@utils/fetch-ssr/fetcher";

export const getPolicyFromApi = (type: string) => {
  const options = {
    method: "GET",
    uri: `mytens-explore/v1/legal`,
    params: {
      docType: type
    },
  };

  return callAPI(options);
};

export const getCookiesPolicyFromApi = (lang: string) => {
  const options = {
    method: "GET",
    uri: `mytens-explore/v1/legal/cookies-policy`,
    additionalHeader: {
      lang: lang
    }
  };

  return callAPI(options);
};

export const postUserConsentFromApi = (data: ICookieConsent) => {
  const options = {
    method: "POST",
    uri: `mytens-explore/v1/legal/cookies-policy/user-consent`,
    params: data
  };

  return callAPI(options);
};
